import React from 'react'
import './Display.css'

const display = props => 
<div className="display">{props.value}</div>

export default display